(() => {
  'use strict';

  const PUMPKIN_TIMELINE_ACTIVATION_OFFSET = 200;

  class PumpkinPdpJourneyTimelineElement extends HTMLElement {
    connectedCallback() {
      this.pumpkinMilestones = this.querySelectorAll('.pumpkin_pdp_journey_timeline__milestone');
      if (!this.pumpkinMilestones.length) return;

      this.handlePumpkinIntersect = this.handlePumpkinIntersect.bind(this);

      this.pumpkinObserver = new IntersectionObserver(this.handlePumpkinIntersect, {
        rootMargin: `0px 0px -${PUMPKIN_TIMELINE_ACTIVATION_OFFSET}px 0px`,
        threshold: [0, 0.25, 0.5, 0.75, 1],
      });

      this.pumpkinMilestones.forEach((milestone) => {
        this.pumpkinObserver.observe(milestone);
      });
    }

    disconnectedCallback() {
      this.pumpkinObserver?.disconnect();
    }

    handlePumpkinIntersect(entries) {
      entries.forEach((entry) => {
        if (!entry.rootBounds) return;

        const hasClearedPumpkinLine = entry.boundingClientRect.bottom <= entry.rootBounds.bottom;
        const hasScrolledPastPumpkinTop = entry.boundingClientRect.top <= entry.rootBounds.top;

        entry.target.classList.toggle('is-active', hasClearedPumpkinLine || hasScrolledPastPumpkinTop);
      });
    }
  }

  if (!customElements.get('pumpkin-pdp-journey-timeline')) {
    customElements.define('pumpkin-pdp-journey-timeline', PumpkinPdpJourneyTimelineElement);
  }
})();